// src/ApiService/carePlansApi.js

export const carePlansApi = (api) => ({
  getByCustomer: (customerId) => api.get(`/CarePlans/customer/${customerId}`),
  getById: (id) => api.get(`/CarePlans/${id}`),
  create: (customerId, payload) => api.post(`/CarePlans/${customerId}`, payload),
  update: (id, payload) => api.put(`/CarePlans/${id}`, payload),
  updateSection: (id, type, payload) => api.put(`/CarePlans/${id}/sections/${type}`, payload),
  submit: (id) => api.post(`/CarePlans/${id}/submit`),
  approve: (id) => api.post(`/CarePlans/${id}/approve`),
  archive: (id) => api.post(`/CarePlans/${id}/archive`),
});
